import React from 'react';
import ReactDOM from 'react-dom/client';
import DemoApp from './DemoApp';  // The live game engine (Farm, Playground, ...)
import NavScreen from './NavScreen';
import './index.css';

// ─── Entry routing (2026-08-07) ───
// Bare visit  → NavScreen (choose language → choose adventure).
// ?adventure= → the game, loading that adventure's content pack.
// WordPress lesson links (?token/?lesson_id/?user_id, no adventure param)
//   → straight into the game (Farm default) exactly as before — a kid coming
//     from a course lesson never sees the picker.
const q = new URLSearchParams(window.location.search);
const isWpLink = Boolean(q.get('token') || q.get('lesson_id') || q.get('user_id'));
const showNav = !q.get('adventure') && !isWpLink;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {showNav ? <NavScreen /> : <DemoApp />}
  </React.StrictMode>
);
